import React, { useState } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function FloatButtonMenu({ disabled, menuItems }) {
  const [isClicked, setClicked] = useState(false);

  const hadleClick = () => setClicked(prev => !prev);

  return (
    <S.Container>
      {isClicked && !!menuItems.length && (
        <S.FloatMenu>
          <p>Selecione uma ação</p>
          {menuItems.map((item, index) => (
            <S.FloatMenuItem
              onClick={item.action(hadleClick)}
              key={`btn-${index}`}
            >
              {item.label}
            </S.FloatMenuItem>
          ))}
        </S.FloatMenu>
      )}

      <S.FloatButton
        onClick={hadleClick}
        isDisabled={disabled}
        disabled={disabled}
      >
        <S.Icon isClicked={isClicked} viewBox="0 0 20 20">
          <S.IconPath
            fill="none"
            d="M11.469,10l7.08-7.08c0.406-0.406,0.406-1.064,0-1.469c-0.406-0.406-1.063-0.406-1.469,0L10,8.53l-7.081-7.08
            c-0.406-0.406-1.064-0.406-1.469,0c-0.406,0.406-0.406,1.063,0,1.469L8.531,10L1.45,17.081c-0.406,0.406-0.406,1.064,0,1.469
            c0.203,0.203,0.469,0.304,0.735,0.304c0.266,0,0.531-0.101,0.735-0.304L10,11.469l7.08,7.081c0.203,0.203,0.469,0.304,0.735,0.304
            c0.267,0,0.532-0.101,0.735-0.304c0.406-0.406,0.406-1.064,0-1.469L11.469,10z"
          />
        </S.Icon>
      </S.FloatButton>
    </S.Container>
  );
}

FloatButtonMenu.propTypes = {
  disabled: PropTypes.bool,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      action: PropTypes.func,
    }),
  ),
};

FloatButtonMenu.defaultProps = {
  disabled: false,
  menuItems: [
    {
      label: 'Teste',
      action: cb => e => {
        e.persist();
        cb();
        e.preventDefault();
      },
    },
  ],
};
